import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { FavoritesProvider } from './contexts/FavoritesContext';
import Home from './pages/Home';
import PropertyDetails from './pages/PropertyDetails';
import PropertyList from './pages/PropertyList';
import About from './pages/About';
import Contact from './pages/Contact';
import BookingConfirmed from './pages/BookingConfirmed';
import MyBookings from './pages/MyBookings';
import Account from './pages/Account';
import TermsOfService from './pages/TermsOfService';
import ResetPassword from './pages/ResetPassword';
import Header from './components/Header';
import Footer from './components/Footer';
import 'leaflet/dist/leaflet.css';
import './App.css';

function App() {
  return (
    <FavoritesProvider>
      <AuthProvider>
        <Router>
        <ScrollToTop />
        <div className="min-h-screen bg-gray-50 flex flex-col">
          <Header />
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/properties" element={<PropertyList />} />
              <Route path="/property/:id" element={<PropertyDetails />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/booking-confirmed/:id" element={<BookingConfirmed />} />
              <Route path="/my-bookings" element={<MyBookings />} />
              <Route path="/account" element={<Account />} />
              <Route path="/terms" element={<TermsOfService />} />
              <Route path="/reset-password" element={<ResetPassword />} />
            </Routes>
          </main>
          <Footer />
        </div>
        </Router>
      </AuthProvider>
    </FavoritesProvider>
  );
}

// Separate component to handle scroll-to-top logic
function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return null; // This component doesn't render anything
}

export default App;
